import { render } from "./app-main.vue?vue&type=template&id=e64c493e&scoped=true&ts=true"
import script from "./app-main.vue?vue&type=script&lang=ts"
export * from "./app-main.vue?vue&type=script&lang=ts"

import "./app-main.vue?vue&type=style&index=0&id=e64c493e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/hub_thunnus/hub_thunnus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64c493e"],['__file',"src/layout/app-main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e64c493e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e64c493e', __exports__)) {
    console.log('reload')
    api.reload('e64c493e', __exports__)
  }
  
  module.hot.accept("./app-main.vue?vue&type=template&id=e64c493e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('e64c493e', render)
  })

}


export default __exports__